import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const FIFAPopup = ({ showOnlyOnHome = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Check if popup has been shown in this page load
    const popupShown = window.fifaPopupShown;
    
    // Only show if it hasn't been shown in this page load
    if (!popupShown) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        // Start animation after popup becomes visible
        setTimeout(() => setIsAnimating(true), 50);
      }, 1000); // Increased delay to 1 second for better UX

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsAnimating(false);
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
    // Mark popup as shown for this page load only
    window.fifaPopupShown = true;
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] pointer-events-none">
      {/* Backdrop */}
      <div 
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${
          isAnimating ? 'opacity-50' : 'opacity-0'
        }`}
        onClick={handleClose}
      ></div>
      
      {/* Popup Container */}
      <div className="flex justify-center pt-4 lg:pt-8 mt-16 lg:mt-28 px-2 lg:px-4 pointer-events-none">
        <div 
          className={`relative w-full max-w-[320px] md:max-w-[480px] lg:max-w-[600px] bg-white rounded-xl lg:rounded-2xl shadow-2xl px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10 text-center pointer-events-auto transform transition-all duration-500 ease-out ${
            isAnimating 
              ? 'translate-y-0 opacity-100 scale-100' 
              : '-translate-y-full opacity-0 scale-95'
          }`}
        >
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-2 lg:top-3 right-2 lg:right-3 w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-white hover:bg-black hover:text-white flex items-center justify-center transition-colors duration-200 text-black font-bold text-sm lg:text-base"
            aria-label="Close popup"
          >
            ✕
          </button>

          {/* Title */}
          <h2 className="text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-green-900 mb-1 lg:mb-2 leading-tight">
            FIFA 2026 Special
          </h2>

          {/* Discount */}
          <p className="text-base md:text-xl lg:text-2xl font-semibold text-black mb-2 lg:mb-4">
            10% Off All Rides
          </p>

          {/* Subtitle */}
          <p className="text-black mb-4 lg:mb-6 xl:mb-8 text-xs md:text-sm lg:text-base font-medium px-2 lg:px-0">
            Premium transportation for the World Cup
          </p>

          

          {/* Buttons */}
          <div className="flex flex-col lg:flex-row gap-2 lg:gap-3 xl:gap-4 justify-center">
            <Link
              to="/booknow"
              onClick={handleClose}
              className="bg-black hover:bg-gray-900 text-white font-semibold px-4 md:px-6 lg:px-8 py-2 lg:py-2.5 xl:py-3 rounded-full transition-colors duration-200 text-xs md:text-sm lg:text-base"
            >
              BOOK NOW
            </Link>

            <Link
              to="/fifa-world-cup-2026-transportation"
              onClick={handleClose}
              className=" hover:bg-gray-100 text-black border-black border-2 font-semibold px-4 md:px-6 lg:px-8 py-2 lg:py-2.5 xl:py-3 rounded-full transition-colors duration-200 text-xs md:text-sm lg:text-base"
            >
              SCHEDULE
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FIFAPopup;
